export default function getAndroidFile(fileUri) {
  return new Promise((resolve, reject) => {
    window.resolveLocalFileSystemURL(fileUri, resolve, reject);
  }).then(fileEntry => {
    return new Promise((resolve, reject) => {
      fileEntry.file(resolve, reject);
    });
  }).then(file => {
    return file;
  });
}
